import $ from 'gridstrap/lib/gs-zepto';

export class GSOutlineButton {

	//
	// Properties
	//

	private root;
	private peers;
	private group;

	get groupName()       { return this.root.data('gsOutlineButtonGroup'); }
	get isSelected()      { return this.root.hasClass('is-selected'); }
	set isSelected(value) { this.root.toggleClass('is-selected', !!value); }

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);

		if (!!this.groupName) {
			this.peers = $(`[data-gs-outline-button-group="${this.groupName}"]`).not(this.root);
			this.root.on('click', evt => this.handleClick(evt));
		}
	}

	handleClick(evt) {
		this.isSelected = true;
		this.peers.gs('isSelected', false);
	}
}
